// extracted by mini-css-extract-plugin
module.exports = {"sub":"index_sub__XEzwH"};